import { render, staticRenderFns } from "./describeImage.vue?vue&type=template&id=c100c54c&scoped=true&"
import script from "./describeImage.vue?vue&type=script&lang=js&"
export * from "./describeImage.vue?vue&type=script&lang=js&"
import style0 from "./describeImage.vue?vue&type=style&index=0&id=c100c54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c100c54c",
  null
  
)

export default component.exports